import { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import Slide from '../../atoms/Slide'

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
`

const SliderWrapper = styled.div`
  display: flex;
  width: 100%;
  touch-action: pan-y;
  user-select: none;
`

const DRAG_THRESHOLD = 60

const SlideList = ({ datas, currentIndex, setCurrentIndex }) => {
  const [moveX, setMoveX] = useState(0)
  const [wrapperWidth, setWrapperWidth] = useState(0)

  const wrapperRef = useRef(null)
  const isDraggingRef = useRef(false)
  const startXRef = useRef(0)
  const moveXRef = useRef(0)

  // width 측정 
  useEffect(() => {
    const updateWidth = () => {
      if (wrapperRef.current) {
        setWrapperWidth(wrapperRef.current.clientWidth)
      }
    }
    updateWidth()
    window.addEventListener('resize', updateWidth)
    return () => window.removeEventListener('resize', updateWidth)
  }, [])

  // pointer down
  const handlePointerDown = (e) => {
    e.currentTarget.setPointerCapture(e.pointerId)

    isDraggingRef.current = true
    startXRef.current = e.clientX
    moveXRef.current = 0
  }

  // pointer move
  const handlePointerMove = (e) => {
    if (!isDraggingRef.current) return

    const deltaX = e.clientX - startXRef.current
    moveXRef.current = deltaX
    setMoveX(deltaX)
  }

  const handlePointerUp = (e) => {
    if (!isDraggingRef.current) return

    e.currentTarget.releasePointerCapture(e.pointerId)

    const deltaX = moveXRef.current

    if (Math.abs(deltaX) > DRAG_THRESHOLD) {
      if (deltaX > 0 && currentIndex > 0) {
        setCurrentIndex((prev) => prev - 1)
      }
      if (deltaX < 0 && currentIndex < datas.length - 1) {
        setCurrentIndex((prev) => prev + 1)
      }
    }

    isDraggingRef.current = false
    moveXRef.current = 0
    setMoveX(0)
  }

  return (
    <Wrapper>
      <SliderWrapper
        ref={wrapperRef}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerUp}
        onPointerCancel={handlePointerUp}
        style={{
          transform: `translateX(${-currentIndex * wrapperWidth + moveX}px)`,
          transition: isDraggingRef.current ? 'none' : 'transform 0.3s ease',
        }}
      >
        {datas.map((data) => (
          <Slide
            key={data.imageUrl}
            src={data.imageUrl}
            isDraggingRef={isDraggingRef}
          />
        ))}
      </SliderWrapper>
    </Wrapper>
  )
}

export default SlideList
